'use strict';

var GridPrintButtonController = function GridPrintButtonController($scope, printService, columnNameTransformationService) {
  var gridPanel = $scope.gridPanelScope;
  $scope.printGrid = function () {
    var columnsToHide = columnNameTransformationService.getColumnsToHide(gridPanel.jqxGridSettings);
    columnNameTransformationService.hideColumns(gridPanel.jqxGridSettings, columnsToHide);
    gridPanel.asyncGridApply('exportdata', 'html').then(function (gridContent) {
      columnNameTransformationService.unhideColumns(gridPanel.jqxGridSettings, columnsToHide);
      gridContent = columnNameTransformationService.flattenColumnNames(gridContent, gridPanel.jqxGridSettings, 'html');
      printService.print(gridPanel.gridId, gridContent);
    });
  };
};
GridPrintButtonController.$inject = ['$scope', 'PrintService', 'ColumnNameTransformationService'];
module.exports = GridPrintButtonController;